module.exports = __webpack_public_path__ + "media/bootstrap-icons/film-421d072d.svg";